import { STRIPE_PUBLISHABLE_KEY } from "@/config/stripe";
import { loadStripe, Stripe } from "@stripe/stripe-js";

let stripePromise: Promise<Stripe | null> | null = null;

export function getStripe(): Promise<Stripe | null> {
    if (!STRIPE_PUBLISHABLE_KEY) {
        console.error(
            "Stripe publishable key is missing. Set EXPO_PUBLIC_STRIPE_PUBLISHABLE_KEY.",
        );

        return Promise.resolve(null);
    }

    if (!stripePromise) {
        stripePromise = loadStripe(STRIPE_PUBLISHABLE_KEY);
    }

    return stripePromise;
}
